"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Alert = _interopRequireDefault(require("../Alert/Alert"));
var _Tooltip = _interopRequireDefault(require("../Tooltip/Tooltip"));
var _Svg = _interopRequireDefault(require("../Svg/Svg"));
var _constants = require("../constants");
var FormToggle = function FormToggle(_ref) {
  var label = _ref.label,
    disabled = _ref.disabled,
    required = _ref.required,
    name = _ref.name,
    value = _ref.value,
    alert = _ref.alert,
    description = _ref.description,
    checked = _ref.checked,
    onChange = _ref.onChange,
    tooltip = _ref.tooltip,
    className = _ref.className,
    labelHidden = _ref.labelHidden;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(className, " d8-c-toggle margin-bottom-sm ").concat(disabled && 'disabled')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-bottom-md inline-flex items-center"
  }, !labelHidden && /*#__PURE__*/_react["default"].createElement("span", {
    className: "form-label"
  }, label), tooltip && /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-left-sm"
  }, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: tooltip
  }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: "info-i-fill",
    fill: _constants.COLORS.CONTRAST_MEDIUM
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: label.replace(/\s+/g, '-').toLowerCase(),
    className: "toggle--wrap flex-shrink-0"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    disabled: disabled,
    type: "checkbox",
    name: name,
    value: value,
    className: "form-control d8-u-absolute",
    required: required,
    id: label.replace(/\s+/g, '-').toLowerCase(),
    "aria-label": label,
    title: label,
    checked: checked,
    onChange: onChange
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "toggle--slider"
  })), description && /*#__PURE__*/_react["default"].createElement("span", {
    className: "margin-left-sm s-font d8-u-ls-sm"
  }, description)), alert && /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    className: "margin-top-sm",
    show: alert.showNotification,
    text: alert.notificationMessage,
    type: alert.notificationType,
    onClose: alert.onClose
  }));
};
FormToggle.propTypes = {
  label: _propTypes["default"].string,
  labelHidden: _propTypes["default"].bool,
  name: _propTypes["default"].string,
  value: _propTypes["default"].string,
  description: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  checked: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  alert: _propTypes["default"].object,
  tooltip: _propTypes["default"].string,
  className: _propTypes["default"].string
};
FormToggle.defaultProps = {
  required: false,
  alert: null
};
var _default = exports["default"] = FormToggle;